import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BranchDto, ProjectDto, TechnologyDto, RoleDto } from 'src/app/services/api-client/models';
import { BranchRestControllerService, ProjectRestControllerService, ProjectRoleRestControllerService, TechnologyRestControllerService } from 'src/app/services/api-client/services';
import { ToastrService } from 'ngx-toastr';
import { now } from 'moment';
import { ProjectRolesEnum } from 'src/app/shared/enums/projectRoles.model';
import { ProjectTypeEnum } from 'src/app/shared/enums/project-type.model';
import { Subscription } from 'rxjs';
import { CvTypeEnum } from 'src/app/shared/enums/cvType.model';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Sorting } from 'src/app/shared/sorting';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDeletionPopupComponent } from 'src/app/shared/components/confirm-deletion-popup/confirm-deletion-popup.component';
import Quill from 'quill';
import { MatAccordion } from '@angular/material/expansion';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { finalize, switchMap } from 'rxjs/operators';

export interface DetailsToggle {
  projId: number,
  isDetailsEnabled: boolean
}
export interface RoleTechnologyCounter {
  projId: number,
  numberOfSelectedRoles: number,
  numberOfSelectedTechnologies: number
}
export interface ProjectRoles {
  projId: number,
  roles: RoleDto[]
}
@Component({
  selector: 'app-project-data',
  templateUrl: './project-data.component.html',
  styleUrls: ['./project-data.component.scss']
})
export class ProjectDataComponent implements OnInit, OnChanges {
  @Input() cvId: number = null;
  @Input() cvType: CvTypeEnum = null;
  @Input() projects: ProjectDto[] = [];
  @Output() projectsChanged = new EventEmitter<any>();
  @ViewChild(MatAccordion) accordion;

  public isEnabled = true;

  public dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false,
    allowSearchFilter: true
  };
  projectApproaches = ['CLASSIC', 'AGILE', 'HYBRID']

  detailsEnabled: DetailsToggle [] = [];
  enableProjects: DetailsToggle [] = [];

  public branches: BranchDto[] = [];
  public allTechnologies: TechnologyDto[] = [];
  public allRoles: RoleDto[] = [];

  counter: RoleTechnologyCounter[] = [];

  projectsForm: FormGroup;
  defaultSubscription: Subscription;

  isNewProjEnabled= false;
  newProj: ProjectDto = {
    id: -now(),
    orderBy: null,
    selected: true,
    name: null,
    projectApproach: null,
    type: null,
    branch: null,
    customer: null,
    taskDescription: null,
    description: null,
    highlight: null,
    startDate: null,
    endDate: null,
    duration: null,
    roles:[],
    technologies:[]
  };
  isConsult = false;
  itemIndex: number; // do not remove! It is using in html
  sortAsc: Boolean = null;
  isProjectsSaving = false;

  modules = {
    'toolbar': [
      [{'list': 'bullet'}],
    ]
  }

  constructor(
    private sorting: Sorting,
    private fb: FormBuilder,
    private translate: TranslateService,
    private projectService: ProjectRestControllerService,
    private brancheService: BranchRestControllerService,
    private technologyService: TechnologyRestControllerService,
    private roleService: ProjectRoleRestControllerService,
    private toastrService: ToastrService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef
    ) {
    }

  ngOnInit(): void {
    this.projects = this.projects.filter(pr => pr);
    if (this.cvType === CvTypeEnum.CONSULTANT_CV) {
      this.isConsult = true;
    }
    this.isEnabled = !this.isConsult;

    this.projectsForm = this.fb.group({
      backendProjects: new FormArray([], [Validators.required])
    });
    this.loadData();
    if(this.translate.currentLang == 'en') {
      this.dropdownSettings.textField = 'nameEn';
    }
  };

  ngOnChanges(changes: SimpleChanges): void {
    let projectChanges: ProjectDto[] = changes.projects?.currentValue;
    if(projectChanges && !changes.projects.firstChange) {
      this.projectsForm = this.fb.group({
        backendProjects: new FormArray([], [Validators.required])
      });
      this.projects = projectChanges.filter(pr => pr);
      this.counter = [];
      this.loadData();
      // resubscribe because form changed:
      this.defaultSubscription.unsubscribe();
      this.checkDirty();
    }
  }

  checkDirty() {
    return this.projectsForm.valueChanges.subscribe((change:any) => {
      if (this.projectsForm.dirty || this.projectsForm.touched) {
        this.projectsChanged.emit(change);
      }
    });
  }

  setAmountOfRolesAndTechnologies(p: ProjectDto): void {
    let rNumber = 0, tNumber = 0;
    if(p.roles) rNumber = p.roles.length;
    if(p.technologies) tNumber = p.technologies.length;
    this.counter.push({projId: p.id, numberOfSelectedRoles: rNumber, numberOfSelectedTechnologies: tNumber});
  }

  presetDetailsEnabled() {
    if (this.projects && this.projects.length != 0) {
      this.detailsEnabled = [];
      this.projects.forEach(proj => {
        this.detailsEnabled.push({projId: proj.id, isDetailsEnabled: true});
      })
    }
  }

  loadData() {
    this.technologyService.getAllTechnologies().pipe(
      switchMap((data: TechnologyDto[]) => {
        this.allTechnologies = data;
        this.sortListItems(this.allTechnologies);
        return this.roleService.getProjectRoles();
      }),
      switchMap((data: RoleDto[]) => {
        this.allRoles = data;
        this.sortListItems(this.allRoles);
        return this.brancheService.getBranches();
      }),
    ).subscribe((data: BranchDto[]) => {
      this.branches = data;
      this.sortListItems(this.branches);
      for(let x in this.projects){
        if (this.projects[x].id == null) {
          this.projects[x].id = -now() - parseInt(x);
        }
        (this.projectsForm.get('backendProjects') as FormArray).push(new FormGroup(
          {
            id: new FormControl(this.projects[x].id),
            selected: new FormControl((this.projects[x].selected === null || this.projects[x].selected === undefined) ? true : this.projects[x].selected),
            name: new FormControl(this.projects[x].name,[Validators.required]),
            projectApproach: new FormControl(this.projects[x].projectApproach,[Validators.required]),
            type: new FormControl(this.projects[x].type,[Validators.required]),
            branch: new FormControl(this.loadBranch(x)),
            customer: new FormControl(this.projects[x].customer,[Validators.required]),
            taskDescription: new FormControl(this.projects[x].taskDescription,[Validators.required, Validators.maxLength(1600)]),
            description: new FormControl(this.projects[x].description,[Validators.required, Validators.maxLength(600)]),
            highlight: new FormControl(this.projects[x].highlight,[Validators.required, Validators.maxLength(500)]),
            startDate: new FormControl(this.projects[x].startDate,[Validators.required]),
            endDate: new FormControl(this.projects[x].endDate,[Validators.required]),
            duration: new FormControl({value: this.projects[x].duration, disabled: true}),
            roles: new FormControl(this.loadRoles(x), Validators.required),
            technologies: new FormControl(this.loadTechnologies(x), Validators.required),
            isNewProject: new FormControl(false,[Validators.required])
          })
        );
        this.checkDates(this.projects[x].startDate, this.projects[x].endDate);
        this.enableProjects.push({projId: this.projects[x].id, isDetailsEnabled: this.projects[x].selected})
      }
      this.presetDetailsEnabled();
      this.projects.forEach((p:ProjectDto, i: number ) => {
        this.setAmountOfRolesAndTechnologies(p);
      });
      this.projectsForm.markAsPristine();
      this.projectsForm.markAsUntouched();
      this.checkSorting();
      this.defaultSubscription = this.checkDirty();
    });
  }

  loadBranch(projectIndex: string): BranchDto {
    if (this.projects && this.projects[projectIndex]?.branch) {
      return this.branches.find((branch) => branch.id === this.projects[projectIndex].branch.id);
    }
  }

  loadRoles(projectIndex: string): any{
    let controls=[];
    if (this.projects && this.projects[projectIndex]?.roles) {
      this.projects[projectIndex].roles.forEach((role:RoleDto) => {
        controls.push(this.allRoles.find((r) => r.id === role.id));
      })
    }
    return controls;
  }

  loadTechnologies(projectIndex: string): any{
    let controls=[];
    if (this.projects && this.projects[projectIndex]?.technologies) {
      this.projects[projectIndex].technologies.forEach((tech: TechnologyDto) => {
        controls.push(this.allTechnologies.find((t) => t.id === tech.id));
      })
    }
    return controls;
  }
  get backendProjects(): FormArray {
    return this.projectsForm.get('backendProjects') as FormArray;
  };

  sortListItems(arr: any[]) {
    return this.translate.currentLang == 'en' ?
      arr.sort((item1, item2) => {return this.sorting.compare(item1.nameEn, item2.nameEn)}) :
        arr.sort((item1, item2) => {return this.sorting.compare(item1.name, item2.name);})
  }

  toggleProjectDetails(projId: number): void {
    this.detailsEnabled.forEach(element => {
      if (projId == element.projId) {
        element.isDetailsEnabled = !(element.isDetailsEnabled);
      }
    });
  }

  showDetails(projId: number): boolean {
    if (this.backendProjects.controls.filter(control => control.get('id').value < 0).length == 0 && projId < 0) {
      return true;
    }
    let oneOfProj = this.detailsEnabled.find(x=> x.projId == projId);
    return oneOfProj.isDetailsEnabled;
  }

  toggleProjects(): void {
    this.isEnabled = !this.isEnabled;
    this.isEnabled ? this.accordion.openAll() : this.accordion.closeAll();
  }

  onRoleSelect($event, projId: number) {
    (this.counter.find(item => item.projId == projId).numberOfSelectedRoles)++;
  }

  onTechnologySelect($event, projId: number) {
    (this.counter.find(item => item.projId == projId).numberOfSelectedTechnologies)++;
  }

  onRoleDeSelect($event: RoleDto, projId: number) {
    (this.counter.find(item => item.projId == projId).numberOfSelectedRoles)--;
  }

  onTechnologyDeSelect($event: TechnologyDto, projId: number) {
    (this.counter.find(item => item.projId == projId).numberOfSelectedTechnologies)--;
  }

  getProjectRoleKeys() {
    return Object.keys(ProjectRolesEnum);
  }

  getProjectTypeKeys() {
    return Object.keys(ProjectTypeEnum);
  }

  getDuration(start: string, end: string): number {
    let endYear  = new Date(end).getFullYear();
    let startYear = new Date(start).getFullYear();
    let endMonth  = new Date(end).getMonth();
    let startMonth = new Date(start).getMonth();
    if (this.checkDates(start, end)) {
      let duration = (endYear-startYear-1)*12 + endMonth+(13-startMonth);
      return duration;
    } else return null;
  }

  getDiff(start: string, end: string):number {
    let endDate  = new Date(end).getTime();
    let startDate = new Date(start).getTime();
    return (endDate-startDate);
  }

  checkDates(start: string, end: string): boolean {
    return (this.getDiff(start, end) > 0);
  }

  getCounter(projId: number): RoleTechnologyCounter {
    return this.counter.find(el => el.projId == projId);
  }

  submit() {
    const formValue = this.projectsForm.value;
    if (this.projectsForm.valid) {
      let isOK: boolean = true;
      const projects: ProjectDto[] = formValue.backendProjects;
      if (projects.length != 0) {
        projects?.forEach(p => {
          if (!this.checkDates(p.startDate, p.endDate)) { isOK = false; }
        });
      } else {
        let start = formValue.backendProjects[0].get('startDate').value;
        let end = formValue.backendProjects[0].get('endDate').value;
        if (!this.checkDates(start, end)) { isOK = false; }
      }
      if (!isOK) {
        this.toastrService.error("Änderungen sind nicht gespeichert!");
        this.toastrService.warning("Fehler beim Speichern! Bitte die Datums in Projekten überprüfen!");
      } else {
        this.saveProjects(projects);
      }
    }
  }

  saveProjects(projects: ProjectDto[]) {
    this.isProjectsSaving = true;
    const datepipe: DatePipe = new DatePipe('en-US');
    const tempIdByIndex: number[] = projects.map(p => (p.id ?? -1));
    projects.forEach((p, idx) => {
      p.duration = this.getDuration(p.startDate, p.endDate);
      p.startDate = datepipe.transform(new Date(p.startDate), 'yyyy-MM-dd');
      p.endDate = datepipe.transform(new Date(p.endDate), 'yyyy-MM-dd');
      // Technologies need to have all values
      let fullTechList:TechnologyDto[] = [];
      p.technologies?.forEach((tech) =>
        fullTechList.push(this.allTechnologies.find((allTech) => allTech.id == tech.id))
      );
      p.orderBy = idx + 1;
      p.technologies = fullTechList;
      // Roles need to have all values
      let fullRoleList:RoleDto[] = [];
      p.roles?.forEach((role) =>
        fullRoleList.push(this.allRoles.find((allRole) => allRole.id == role.id))
      );
      p.roles = fullRoleList;
      // Branch needs to have all values
      p.branch = this.branches.find((allBranch) => allBranch.id == p.branch.id);
      let tmpId = p.id;
      if (p.id < 0) {
        p.id = null;
      }
    })

    this.projectService.batchCreateOrUpdateProjects({cvId: this.cvId, body: projects})
    .pipe(finalize(() => this.isProjectsSaving = false))
    .subscribe(saved => {
        saved.forEach((sv, i) => {
          const ctrl = this.backendProjects.at(i);
          const prevTemp = tempIdByIndex[i];
          if (prevTemp != null && prevTemp < 0) {
            const d = this.detailsEnabled.find(x => x.projId === prevTemp);
            if (d) d.projId = sv.id;
          
            const c = this.counter.find(x => x.projId === prevTemp);
            if (c) c.projId = sv.id;
          }
          
          ctrl.get('id')?.setValue(sv.id);
        
          ctrl.patchValue({
            name: sv.name,
            startDate: sv.startDate,
            endDate: sv.endDate,
            duration: sv.duration,
            branch: sv.branch,
            roles: sv.roles,
            technologies: sv.technologies
          }, { emitEvent: false });

          this.projects = saved;

          this.backendProjects.markAsPristine();
          this.projectsForm.markAsPristine();
          this.projectsChanged.emit(null);
          this.cdr.detectChanges();
        });
        this.translate.get('project_data_saved').subscribe(msg => {
          this.toastrService.success(msg);
        });
      })
  }

  saveProject(project: ProjectDto, index: number, isSingleSave: boolean) {
    if (!this.checkDates(project.startDate, project.endDate)) {
      this.toastrService.error("Änderungen sind nicht gespeichert!");
      this.toastrService.warning("Fehler beim Speichern! Bitte die Datums in Projekten überprüfen!");
    } else {
      const datepipe: DatePipe = new DatePipe('en-US');
      project.duration = this.getDuration(project.startDate, project.endDate);
      project.startDate = datepipe.transform(new Date(project.startDate), 'yyyy-MM-dd');
      project.endDate = datepipe.transform(new Date(project.endDate), 'yyyy-MM-dd');
      // Technologies need to have all values
      let fullTechList:TechnologyDto[] = [];
      project.technologies?.forEach((tech) =>
        fullTechList.push(this.allTechnologies.find((allTech) => allTech.id == tech.id))
      );

      project.orderBy = isSingleSave && this.isFormContainNewProject() ? index - 1 : index;
      
      project.technologies = fullTechList;
      // Roles need to have all values
      let fullRoleList:RoleDto[] = [];
      project.roles?.forEach((role) =>
        fullRoleList.push(this.allRoles.find((allRole) => allRole.id == role.id))
      );
      project.roles = fullRoleList;
      // Branch needs to have all values
      project.branch = this.branches.find((allBranch) => allBranch.id == project.branch.id);
      let tmpId = project.id;
      if (project.id < 0) {
        project.id = null;
      }
      this.projectService.createOrUpdateProject({cvId: this.cvId.toString(), body: project})
      .subscribe((response: ProjectDto) => {
        if (!project.id) {
          project.id = tmpId;
          this.projects.forEach((el, i) => {
            if (el.id == tmpId) {
              this.projects.splice(i, 1);
            }
          });
          project.id = response.id;
          project = response;
          this.detailsEnabled.find(details => details.projId == tmpId).projId = project.id;
          this.counter.find(el => el.projId == tmpId).projId = project.id;
          this.projects.push(response);
        }
        this.backendProjects.controls[index].get('id').setValue(response.id);
        this.backendProjects.controls[index].patchValue({
          name: project.name
        })
        this.backendProjects.markAsPristine();
        this.projectsForm.markAsPristine();
        this.projectsChanged.emit(null);
        this.cdr.detectChanges();
        this.translate.get('project_data_saved').subscribe(message => {
          this.toastrService.success(message, project.name);
        });
      }, (e) => {
        console.log('Error! Failed to save data', e);
        this.toastrService.error("Project wurde nicht gespeichert!", project.name);
      });
    }
  }

  isFormContainNewProject() {
    return this.projectsForm.value.backendProjects.some(proj => proj.isNewProject && proj.id < 0);
  }

  checkSelectedItems(): boolean {
    let selectedR = 0;
    let selectedT = 0;
    this.counter.forEach(sr => {
      if (sr.numberOfSelectedRoles<1) {
        selectedR++;
      }
    });
    this.counter.forEach(st => {
      if (st.numberOfSelectedTechnologies<1) { selectedT++; }
    });
    return (selectedR == 0 && selectedT == 0);
  }

  checkSingleSelectedItems(projId: number): boolean {
    const counterObject = this.counter.find(count => count.projId == projId);
    return counterObject.numberOfSelectedRoles > 0 && counterObject.numberOfSelectedTechnologies > 0;
  }

  openNewProjectDialog() {
    this.isNewProjEnabled = true;
    let newProject: ProjectDto = this.newProj;
    this.createNewProjectForm(newProject);
    this.projects = this.projectsForm.value.backendProjects;
    let newP: ProjectDto = this.projects.find( p => p.id == newProject.id);
    this.setAmountOfRolesAndTechnologies(newP);
    this.presetDetailsEnabled();
  }

  createNewProjectForm (p: ProjectDto) {
    let arr = (this.projectsForm.get('backendProjects') as FormArray);
    this.enableProjects.push({projId: p.id, isDetailsEnabled: true});
    arr.insert(0, new FormGroup(
      {
        id: new FormControl(p.id),
        name: new FormControl(p.name,[Validators.required]),
        selected: new FormControl(true),
        projectApproach: new FormControl(p.projectApproach,[Validators.required]),
        type: new FormControl(p.type,[Validators.required]),
        branch: new FormControl(p.branch),
        customer: new FormControl(p.customer,[Validators.required]),
        taskDescription: new FormControl(p.taskDescription,[Validators.required, Validators.maxLength(1200)]),
        description: new FormControl(p.description,[Validators.required, Validators.maxLength(600)]),
        highlight: new FormControl(p.highlight,[Validators.required, Validators.maxLength(500)]),
        startDate: new FormControl(p.startDate,[Validators.required]),
        endDate: new FormControl(p.endDate,[Validators.required]),
        duration: new FormControl({value: p.duration, disabled: true}),
        roles: new FormControl(p.roles, Validators.required),
        technologies: new FormControl(p.technologies, Validators.required),
        isNewProject: new FormControl(true,[Validators.required])
      })
    );
    console.log(arr)
  }

  removeProject (index:number, projId: number) {
    const formValue = this.projectsForm.value;
    let formProjects: ProjectDto[] = formValue.backendProjects;
    if (!formProjects[index].id || formProjects[index].id < 0) {
      this.projects.splice(index, 1);
      this.updateCounter(projId);
      this.backendProjects.removeAt(index);
    } else {
        this.dialog.open(ConfirmDeletionPopupComponent, {
          width: '370px',
          disableClose: true,
          autoFocus: false,
          position: {top: '20px'},
          data: {
            title: this.translate.instant('delete_project_title', { project_name: formProjects[index].name }),
            message: this.translate.instant('delete_project_message')
          }
        }).afterClosed().subscribe(isConfirmed => {
          if (isConfirmed) {
            let projects: ProjectDto[] = formProjects.slice(index, index+1);
            const deleteDto = projects[0];
            const datepipe: DatePipe = new DatePipe('en-US');
            deleteDto.startDate = datepipe.transform(new Date(deleteDto.startDate), 'yyyy-MM-dd');
            deleteDto.endDate = datepipe.transform(new Date(deleteDto.endDate), 'yyyy-MM-dd');
            this.projectService.deleteProject({cvId: this.cvId, body: deleteDto})
            .subscribe(() => {
              this.projects.splice(index, 1);
              this.updateCounter(projId);
              this.backendProjects.removeAt(index);
              this.toastrService.success("Projekt erfolgreich gelöscht.", null);
            });
          }
        })
    }
    if (this.backendProjects.length<1) {
      this.projectsChanged.emit(null);
    }
  }

  updateCounter (projId: number) {
    const index = this.counter.findIndex(el => el.projId == projId);
    if (index != -1) {
      this.counter.splice(index, 1);
    }
  }

  handleSelect(i: number) {
    let isSelected = !this.backendProjects.controls[i].get('selected').value;
    let name = this.backendProjects.controls[i].get('name').value;
    let element = this.projects.find(x=> x.name == name);
    if (element) {
      isSelected = !element.selected;
      this.projects.find(x=> x.name == name).selected = isSelected;
    }
    this.backendProjects.controls[i].get('selected').setValue(isSelected);
  }

  isSelected(i: number): boolean {
    return this.backendProjects.controls[i].get('selected').value;
  }

  compareObjects(a, b): boolean {
    if(a && b) {
      if(a.id == b.id) return true;
      else return false;
    } else if(!a && !b) return true;
      else return false;
  }

  itemDropped(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.backendProjects.controls, event.previousIndex, event.currentIndex);
    moveItemInArray(this.backendProjects.value, event.previousIndex, event.currentIndex);
    this.projectsChanged.emit(true)
  }

  editorInit(quill: Quill){
    quill.formatText(0, quill.getText().length - 1, 'color', '');
    quill.clipboard.addMatcher(Node.ELEMENT_NODE, function(node, delta){
      delta.forEach(e => {
        if(e.attributes){
          e.attributes.color = '';
          e.attributes.background = '';
        }
      });
      return delta;
    });
  }

  sortByDate() {
    this.backendProjects.controls.sort((a, b) => {
      if (this.sortAsc) {
        return new Date(a.value.endDate).getTime() - new Date(b.value.endDate).getTime();
      } else {
        return new Date(b.value.endDate).getTime() - new Date(a.value.endDate).getTime();
      }
    });
    this.backendProjects.value.sort((a, b) => { 
      if (this.sortAsc) {
        return new Date(a.endDate).getTime() - new Date(b.endDate).getTime();
      } else {
        return new Date(b.endDate).getTime() - new Date(a.endDate).getTime();
      }
    });

    this.sortAsc = !this.sortAsc;
  }

  checkSorting() {
    let isAsc = true;
    let isDesc = true;

    for (let i = 1; i < this.backendProjects.value.length; i++) {
      const prevDate = new Date(this.backendProjects.value[i - 1].endDate).getTime();
      const currDate = new Date(this.backendProjects.value[i].endDate).getTime();
    
      if (prevDate < currDate) {
        isAsc = false;
      }
      if (prevDate > currDate) {
        isDesc = false;
      }
    }

    if (isAsc) {
      this.sortAsc = true;
    } else if (isDesc) {
      this.sortAsc = false;
    } else {
      this.sortAsc = null;
    }
  }

  getSortTooltipLabel() {
    if (this.sortAsc === null) return `${this.translate.instant('sort_by_end_date_tooltip')}
    ${this.translate.instant('sort_state_not_sorted')}`;
    return `${this.translate.instant('sort_by_end_date_tooltip')}
    ${this.sortAsc ? this.translate.instant('sort_state_new_to_old') : this.translate.instant('sort_state_old_to_new')}`;
  }

  compareById = (a: BranchDto, b: BranchDto) => {
    return a?.id === b?.id;
  };
}
